<template>
  <div class="relative pb-20 w-full h-full container-works space-y-8">

    <div class="w-full h-full space-y-8 relative z-3">
      <!-- <h2 class="font-medium inline-flex text-2xl big-screen:text-[3vw] leading-[1] animation-content-motion opacity-0 translate-y-[10%]">
        <div class="highlighter higlighter-0 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "Motion Graphics" }}</span>
      </h2> -->
      <div class="space-y-8 animation-content-motion opacity-0 translate-y-[10%]">
        <div v-for="item in Works3DAnimation" class="cursor-pointer space-y-3 h-fit" @click="openLink(item.href)">
          <figure class="shadow-lg rounded-xl aspect-square overflow-hidden">
            <img class="object-cover w-full h-full image scale-[1] opacity-0" :src="item.thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-base xl:text-[1vw] font-medium">{{ item.title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full h-full space-y-8 relative z-3">
      <!-- <h2 class="font-medium inline-flex text-2xl big-screen:text-[3vw] leading-[1] animation-content-animation opacity-0 translate-y-[10%]">
        <div class="highlighter higlighter-1 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "3D Animation" }}</span>
      </h2> -->
      <div class="space-y-8 animation-content-animation opacity-0 translate-y-[10%]">
        <div v-for="item in WorksMotion" class="cursor-pointer space-y-3 h-fit" @click="openLink(item.href)">
          <figure class="shadow-lg rounded-xl aspect-square overflow-hidden">
            <img class="object-cover w-full h-full image scale-[1] opacity-0" :src="item.thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-base xl:text-[1vw] font-medium">{{ item.title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full h-full space-y-8 relative z-3">
      <!-- <h2 class="font-medium inline-flex text-2xl big-screen:text-[3vw] leading-[1] animation-content-anamorphic opacity-0 translate-y-[10%]">
        <div class="highlighter higlighter-2 bg-ellie-yellow w-0 h-full absolute top-0 left-0"></div>
        <span class="relative">{{ "3D Anamorphic" }}</span>
      </h2> -->
      <div class="space-y-8 animation-content-anamorphic opacity-0 translate-y-[10%]">
        <div v-for="item in Works3DAnamorphic" class="cursor-pointer space-y-3 h-fit" @click="openLink(item.href)">
          <figure class="shadow-lg rounded-xl aspect-square overflow-hidden">
            <img class="object-cover w-full h-full image scale-[1] opacity-0" :src="item.thumb" alt="Assemble Your Magic Heroes">
          </figure>
          <h2 class="text-base xl:text-[1vw] font-medium">{{ item.title }}</h2>
        </div>
      </div>
    </div>

    <div class="w-full justify-center flex mb-12">
      <div class="inline-flex see-more">
        <NuxtLink to="/works" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)" class="animate-content-paragraph block text-white uppercase border-[0.05vw] border-ellie-blue bg-ellie-blue rounded-full text-sm px-8 py-2 md:px-[1.5vw] md:py-[0.8vw] text-[1.3w] big-screen:text-[1vw] tracking-[0.01vw] hover:bg-opacity-80 hover:text-white transition-colors duration-300">
          View All Projects
        </NuxtLink>
      </div>
    </div>

  </div>
</template>

<script setup>
const { $gsap, $ScrollTrigger } = useNuxtApp();

const init = () => {
  // $gsap
  //   .timeline({
  //     scrollTrigger: {
  //       trigger: '.container-works',
  //       start: '0 0',
  //       end: '100% 100%',
  //       scrub: 1,
  //     },
  //   })
  //   .fromTo('.works-0', { y: 100 }, { y: 0 }, 0)
  //   .fromTo('.works-1', { y: 150 }, { y: 0 }, 0)
  //   .fromTo('.works-2', { y: 200 }, { y: 0 }, 0)

  //   .fromTo('.works-3', { y: 200 }, { y: 0 }, 0)
  //   .fromTo('.works-4', { y: 250 }, { y: 0 }, 0)

  const target0 = document.querySelector('.animation-content-motion');
  const target1 = document.querySelector('.animation-content-animation');
  const target2 = document.querySelector('.animation-content-anamorphic');

  const obsTarget0 = useIntersectionObserver(
    target0,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animation-content-motion');
        observerElement.unobserve(target0);
      }
    },
  );

  const obsTarget1 = useIntersectionObserver(
    target1,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animation-content-animation');
        observerElement.unobserve(target1);
      }
    },
  );

  const obsTarget2 = useIntersectionObserver(
    target2,
    ([entry], observerElement) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0.5) {
        animateContent('animation-content-anamorphic');
        observerElement.unobserve(target2);
      }
    },
  );
};

const animateContent = (target) => {
  $gsap.to(`.${target}`, {
    opacity: 1,
    y: 0,
    stagger: 0.1,
    delay: 0.25,
    ease: 'power1.out',
    // onComplete: () => {
    //   animateHighligter(target);
    // },
  });

  $gsap.to(`.${target} .image`, {
    opacity: 1,
    stagger: 0.3,
    delay: 0.25,
    ease: 'power1.out',
    duration: 1,
  });
};

const animateHighligter = (target) => {
  $gsap.fromTo(
    `h2.${target} .highlighter`,
    { width: 0 }, // Initial state
    {
      width: '100%',
      duration: 0.7, // Animation duration
      stagger: 0.2, // Delay between each element's animation
      ease: 'power2.out', // Ease for smooth animation
    },
  );
};

const Works3DAnimation = ref([
  {
    id: 0,
    title: 'Assemble Your Magic Heroes',
    thumb: '/works/magiclean.webp',
    desc: '',
    href: '/works/kao-magiclean-assemble-your-magic-heroes',
  },
  {
    id: 1,
    title: 'Simmons World Class Sleep',
    thumb: '/works/simmons-bedding.webp',
    desc: '',
    href: '/works/simmons-world-class-sleep',
  },
  {
    id: 2,
    title: 'Gryphon Tea New Packaging',
    thumb: '/works/gryphon.webp',
    desc: '',
    href: '/works/gryphon.webp',
  },
]);
const WorksMotion = ref([
  {
    id: 0,
    title: 'National University Of Singapore Brand',
    thumb: '/works/nus.webp',
    desc: '',
    href: '/works/nus-brandvideo',
  },
  {
    id: 1,
    title: "Lazada's Birthday",
    thumb: '/works/lazada.webp',
    desc: '',
    href: '/works/lazada',
  },
]);

const Works3DAnamorphic = ref([
  {
    id: 0,
    title: "Martell N'oblige 3D Anamorphic",
    thumb: '/works/martell.webp',
    desc: '',
    href: '/works/martell-noblidge',
  },
  {
    id: 1,
    title: 'Singapore’s Exchange IPO Launch',
    thumb: '/works/sgx.webp',
    desc: '',
    // href: '/works/sgx-ipo-launch',
    href: '',
  },

]);

const openLink = (link) => {
  window.open(link, '');
};

onMounted(() => {
  nextTick(() => {
    const to = setTimeout(() => {
      init();
      clearTimeout(to);
    }, 1000);
  });
});
</script>

<style lang="scss" scoped>

</style>
